import { render, staticRenderFns } from "./DigitalRFBasePage.vue?vue&type=template&id=4fbb3673"
import script from "./DigitalRFBasePage.vue?vue&type=script&lang=js"
export * from "./DigitalRFBasePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports